export default __webpack_public_path__ + "static/media/AC_4.a6a8f44d.jpg";